export var Accounts_Constraint;
(function(Accounts_Constraint) {
    /** unique or primary key constraint on columns "api_key" */ Accounts_Constraint["AccountsPkey"] = "Accounts_pkey";
})(Accounts_Constraint || (Accounts_Constraint = {}));
export var Accounts_Select_Column;
(function(Accounts_Select_Column) {
    /** column name */ Accounts_Select_Column["ApiKey"] = "api_key";
    /** column name */ Accounts_Select_Column["BanReason"] = "ban_reason";
    /** column name */ Accounts_Select_Column["BanTimestamp"] = "ban_timestamp";
    /** column name */ Accounts_Select_Column["CanPublishProducts"] = "can_publish_products";
    /** column name */ Accounts_Select_Column["IsBanned"] = "is_banned";
    /** column name */ Accounts_Select_Column["NextTierId"] = "next_tier_id";
    /** column name */ Accounts_Select_Column["NextTierIdTimestamp"] = "next_tier_id_timestamp";
    /** column name */ Accounts_Select_Column["Signature"] = "signature";
    /** column name */ Accounts_Select_Column["TierId"] = "tier_id";
})(Accounts_Select_Column || (Accounts_Select_Column = {}));
export var Accounts_Select_Column_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
(function(Accounts_Select_Column_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns) {
    /** column name */ Accounts_Select_Column_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns["CanPublishProducts"] = "can_publish_products";
    /** column name */ Accounts_Select_Column_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns["IsBanned"] = "is_banned";
})(Accounts_Select_Column_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns || (Accounts_Select_Column_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {}));
export var Accounts_Select_Column_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
(function(Accounts_Select_Column_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns) {
    /** column name */ Accounts_Select_Column_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns["CanPublishProducts"] = "can_publish_products";
    /** column name */ Accounts_Select_Column_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns["IsBanned"] = "is_banned";
})(Accounts_Select_Column_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns || (Accounts_Select_Column_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {}));
export var Accounts_Update_Column;
(function(Accounts_Update_Column) {
    /** column name */ Accounts_Update_Column["ApiKey"] = "api_key";
    /** column name */ Accounts_Update_Column["BanReason"] = "ban_reason";
    /** column name */ Accounts_Update_Column["BanTimestamp"] = "ban_timestamp";
    /** column name */ Accounts_Update_Column["CanPublishProducts"] = "can_publish_products";
    /** column name */ Accounts_Update_Column["IsBanned"] = "is_banned";
    /** column name */ Accounts_Update_Column["NextTierId"] = "next_tier_id";
    /** column name */ Accounts_Update_Column["NextTierIdTimestamp"] = "next_tier_id_timestamp";
    /** column name */ Accounts_Update_Column["Signature"] = "signature";
    /** column name */ Accounts_Update_Column["TierId"] = "tier_id";
})(Accounts_Update_Column || (Accounts_Update_Column = {}));
export var Billing_Select_Column;
(function(Billing_Select_Column) {
    Billing_Select_Column["ApiAccountId"] = "api_account_id";
    Billing_Select_Column["BillingPeriod"] = "billing_period";
    Billing_Select_Column["Cost"] = "cost";
    Billing_Select_Column["CostPerUnit"] = "cost_per_unit";
    Billing_Select_Column["Currency"] = "currency";
    Billing_Select_Column["Id"] = "id";
    Billing_Select_Column["TierId"] = "tier_id";
    Billing_Select_Column["TierName"] = "tier_name";
    Billing_Select_Column["Timestamp"] = "timestamp";
    Billing_Select_Column["Usage"] = "usage";
    Billing_Select_Column["UsageAllowance"] = "usage_allowance";
    Billing_Select_Column["UsageLimit"] = "usage_limit";
    Billing_Select_Column["UsageType"] = "usage_type";
})(Billing_Select_Column || (Billing_Select_Column = {}));
export var CapMessagesVersions_Constraint;
(function(CapMessagesVersions_Constraint) {
    /** unique or primary key constraint on columns "value" */ CapMessagesVersions_Constraint["CapMessagesVersionsPkey"] = "CapMessagesVersions_pkey";
})(CapMessagesVersions_Constraint || (CapMessagesVersions_Constraint = {}));
export var CapMessagesVersions_Enum;
(function(CapMessagesVersions_Enum) {
    CapMessagesVersions_Enum["V0_1"] = "v0_1";
    CapMessagesVersions_Enum["V1"] = "v1";
})(CapMessagesVersions_Enum || (CapMessagesVersions_Enum = {}));
export var CapMessagesVersions_Select_Column;
(function(CapMessagesVersions_Select_Column) {
    /** column name */ CapMessagesVersions_Select_Column["Value"] = "value";
})(CapMessagesVersions_Select_Column || (CapMessagesVersions_Select_Column = {}));
export var CapMessagesVersions_Update_Column;
(function(CapMessagesVersions_Update_Column) {
    /** column name */ CapMessagesVersions_Update_Column["Value"] = "value";
})(CapMessagesVersions_Update_Column || (CapMessagesVersions_Update_Column = {}));
export var CapNetworkVersions_Constraint;
(function(CapNetworkVersions_Constraint) {
    /** unique or primary key constraint on columns "value" */ CapNetworkVersions_Constraint["CapNetworkVersionsPkey"] = "CapNetworkVersions_pkey";
})(CapNetworkVersions_Constraint || (CapNetworkVersions_Constraint = {}));
export var CapNetworkVersions_Enum;
(function(CapNetworkVersions_Enum) {
    CapNetworkVersions_Enum["V0"] = "v0";
})(CapNetworkVersions_Enum || (CapNetworkVersions_Enum = {}));
export var CapNetworkVersions_Select_Column;
(function(CapNetworkVersions_Select_Column) {
    /** column name */ CapNetworkVersions_Select_Column["Value"] = "value";
})(CapNetworkVersions_Select_Column || (CapNetworkVersions_Select_Column = {}));
export var CapNetworkVersions_Update_Column;
(function(CapNetworkVersions_Update_Column) {
    /** column name */ CapNetworkVersions_Update_Column["Value"] = "value";
})(CapNetworkVersions_Update_Column || (CapNetworkVersions_Update_Column = {}));
export var CapRtcVersions_Constraint;
(function(CapRtcVersions_Constraint) {
    /** unique or primary key constraint on columns "value" */ CapRtcVersions_Constraint["CapRtcVersionsPkey"] = "CapRTCVersions_pkey";
})(CapRtcVersions_Constraint || (CapRtcVersions_Constraint = {}));
export var CapRtcVersions_Enum;
(function(CapRtcVersions_Enum) {
    CapRtcVersions_Enum["V0"] = "v0";
})(CapRtcVersions_Enum || (CapRtcVersions_Enum = {}));
export var CapRtcVersions_Select_Column;
(function(CapRtcVersions_Select_Column) {
    /** column name */ CapRtcVersions_Select_Column["Value"] = "value";
})(CapRtcVersions_Select_Column || (CapRtcVersions_Select_Column = {}));
export var CapRtcVersions_Update_Column;
(function(CapRtcVersions_Update_Column) {
    /** column name */ CapRtcVersions_Update_Column["Value"] = "value";
})(CapRtcVersions_Update_Column || (CapRtcVersions_Update_Column = {}));
export var CapVerifyVersions_Constraint;
(function(CapVerifyVersions_Constraint) {
    /** unique or primary key constraint on columns "value" */ CapVerifyVersions_Constraint["CapVerifyVersionsPkey"] = "CapVerifyVersions_pkey";
})(CapVerifyVersions_Constraint || (CapVerifyVersions_Constraint = {}));
export var CapVerifyVersions_Enum;
(function(CapVerifyVersions_Enum) {
    CapVerifyVersions_Enum["V2"] = "v2";
})(CapVerifyVersions_Enum || (CapVerifyVersions_Enum = {}));
export var CapVerifyVersions_Select_Column;
(function(CapVerifyVersions_Select_Column) {
    /** column name */ CapVerifyVersions_Select_Column["Value"] = "value";
})(CapVerifyVersions_Select_Column || (CapVerifyVersions_Select_Column = {}));
export var CapVerifyVersions_Update_Column;
(function(CapVerifyVersions_Update_Column) {
    /** column name */ CapVerifyVersions_Update_Column["Value"] = "value";
})(CapVerifyVersions_Update_Column || (CapVerifyVersions_Update_Column = {}));
export var CapVideoVersions_Constraint;
(function(CapVideoVersions_Constraint) {
    /** unique or primary key constraint on columns "value" */ CapVideoVersions_Constraint["CapVideoVersionsPkey"] = "CapVideoVersions_pkey";
})(CapVideoVersions_Constraint || (CapVideoVersions_Constraint = {}));
export var CapVideoVersions_Enum;
(function(CapVideoVersions_Enum) {
    CapVideoVersions_Enum["V0"] = "v0";
})(CapVideoVersions_Enum || (CapVideoVersions_Enum = {}));
export var CapVideoVersions_Select_Column;
(function(CapVideoVersions_Select_Column) {
    /** column name */ CapVideoVersions_Select_Column["Value"] = "value";
})(CapVideoVersions_Select_Column || (CapVideoVersions_Select_Column = {}));
export var CapVideoVersions_Update_Column;
(function(CapVideoVersions_Update_Column) {
    /** column name */ CapVideoVersions_Update_Column["Value"] = "value";
})(CapVideoVersions_Update_Column || (CapVideoVersions_Update_Column = {}));
export var CapVoiceVersions_Constraint;
(function(CapVoiceVersions_Constraint) {
    /** unique or primary key constraint on columns "value" */ CapVoiceVersions_Constraint["CapVoiceVersionsPkey"] = "CapVoiceVersions_pkey";
})(CapVoiceVersions_Constraint || (CapVoiceVersions_Constraint = {}));
export var CapVoiceVersions_Enum;
(function(CapVoiceVersions_Enum) {
    CapVoiceVersions_Enum["V0"] = "v0";
})(CapVoiceVersions_Enum || (CapVoiceVersions_Enum = {}));
export var CapVoiceVersions_Select_Column;
(function(CapVoiceVersions_Select_Column) {
    /** column name */ CapVoiceVersions_Select_Column["Value"] = "value";
})(CapVoiceVersions_Select_Column || (CapVoiceVersions_Select_Column = {}));
export var CapVoiceVersions_Update_Column;
(function(CapVoiceVersions_Update_Column) {
    /** column name */ CapVoiceVersions_Update_Column["Value"] = "value";
})(CapVoiceVersions_Update_Column || (CapVoiceVersions_Update_Column = {}));
export var DeploymentStatus_Constraint;
(function(DeploymentStatus_Constraint) {
    /** unique or primary key constraint on columns "value" */ DeploymentStatus_Constraint["DeploymentStatusPkey"] = "DeploymentStatus_pkey";
})(DeploymentStatus_Constraint || (DeploymentStatus_Constraint = {}));
export var DeploymentStatus_Enum;
(function(DeploymentStatus_Enum) {
    /** image is being built */ DeploymentStatus_Enum["Building"] = "building";
    /** instance has been deployed */ DeploymentStatus_Enum["Deployed"] = "deployed";
    /** deployment failed */ DeploymentStatus_Enum["Failed"] = "failed";
    /** deployment request has been submitted but build has not started */ DeploymentStatus_Enum["Pending"] = "pending";
})(DeploymentStatus_Enum || (DeploymentStatus_Enum = {}));
export var DeploymentStatus_Select_Column;
(function(DeploymentStatus_Select_Column) {
    /** column name */ DeploymentStatus_Select_Column["Description"] = "description";
    /** column name */ DeploymentStatus_Select_Column["Value"] = "value";
})(DeploymentStatus_Select_Column || (DeploymentStatus_Select_Column = {}));
export var DeploymentStatus_Update_Column;
(function(DeploymentStatus_Update_Column) {
    /** column name */ DeploymentStatus_Update_Column["Description"] = "description";
    /** column name */ DeploymentStatus_Update_Column["Value"] = "value";
})(DeploymentStatus_Update_Column || (DeploymentStatus_Update_Column = {}));
export var Deployments_Constraint;
(function(Deployments_Constraint) {
    /** unique or primary key constraint on columns "id" */ Deployments_Constraint["DeploymentsPkey"] = "Deployments_pkey";
})(Deployments_Constraint || (Deployments_Constraint = {}));
export var Deployments_Select_Column;
(function(Deployments_Select_Column) {
    /** column name */ Deployments_Select_Column["Configuration"] = "configuration";
    /** column name */ Deployments_Select_Column["CreatedAt"] = "created_at";
    /** column name */ Deployments_Select_Column["Environment"] = "environment";
    /** column name */ Deployments_Select_Column["Id"] = "id";
    /** column name */ Deployments_Select_Column["ImageTag"] = "image_tag";
    /** column name */ Deployments_Select_Column["InstanceId"] = "instance_id";
    /** column name */ Deployments_Select_Column["PackageId"] = "package_id";
    /** column name */ Deployments_Select_Column["Status"] = "status";
})(Deployments_Select_Column || (Deployments_Select_Column = {}));
export var Deployments_Update_Column;
(function(Deployments_Update_Column) {
    /** column name */ Deployments_Update_Column["Configuration"] = "configuration";
    /** column name */ Deployments_Update_Column["CreatedAt"] = "created_at";
    /** column name */ Deployments_Update_Column["Environment"] = "environment";
    /** column name */ Deployments_Update_Column["Id"] = "id";
    /** column name */ Deployments_Update_Column["ImageTag"] = "image_tag";
    /** column name */ Deployments_Update_Column["InstanceId"] = "instance_id";
    /** column name */ Deployments_Update_Column["PackageId"] = "package_id";
    /** column name */ Deployments_Update_Column["Status"] = "status";
})(Deployments_Update_Column || (Deployments_Update_Column = {}));
export var Events_Select_Column;
(function(Events_Select_Column) {
    /** column name */ Events_Select_Column["ApiAccountId"] = "api_account_id";
    /** column name */ Events_Select_Column["ApiApplicationId"] = "api_application_id";
    /** column name */ Events_Select_Column["Details"] = "details";
    /** column name */ Events_Select_Column["EventType"] = "event_type";
    /** column name */ Events_Select_Column["Id"] = "id";
    /** column name */ Events_Select_Column["InstanceId"] = "instance_id";
    /** column name */ Events_Select_Column["SessionId"] = "session_id";
    /** column name */ Events_Select_Column["SourceId"] = "source_id";
    /** column name */ Events_Select_Column["SourceType"] = "source_type";
    /** column name */ Events_Select_Column["Timestamp"] = "timestamp";
})(Events_Select_Column || (Events_Select_Column = {}));
export var GithubCredentials_Constraint;
(function(GithubCredentials_Constraint) {
    /** unique or primary key constraint on columns "owner" */ GithubCredentials_Constraint["GithubCredentialsPkey"] = "GithubCredentials_pkey";
})(GithubCredentials_Constraint || (GithubCredentials_Constraint = {}));
export var GithubCredentials_Select_Column;
(function(GithubCredentials_Select_Column) {
    /** column name */ GithubCredentials_Select_Column["Owner"] = "owner";
    /** column name */ GithubCredentials_Select_Column["Token"] = "token";
})(GithubCredentials_Select_Column || (GithubCredentials_Select_Column = {}));
export var GithubCredentials_Update_Column;
(function(GithubCredentials_Update_Column) {
    /** column name */ GithubCredentials_Update_Column["Owner"] = "owner";
    /** column name */ GithubCredentials_Update_Column["Token"] = "token";
})(GithubCredentials_Update_Column || (GithubCredentials_Update_Column = {}));
export var InstanceDebugSessions_Constraint;
(function(InstanceDebugSessions_Constraint) {
    /** unique or primary key constraint on columns "id" */ InstanceDebugSessions_Constraint["InstanceDebugSessionsPkey"] = "InstanceDebugSessions_pkey";
    /** unique or primary key constraint on columns "service_name" */ InstanceDebugSessions_Constraint["InstanceDebugSessionsServiceNameKey"] = "InstanceDebugSessions_service_name_key";
})(InstanceDebugSessions_Constraint || (InstanceDebugSessions_Constraint = {}));
export var InstanceDebugSessions_Select_Column;
(function(InstanceDebugSessions_Select_Column) {
    /** column name */ InstanceDebugSessions_Select_Column["ApiAccountId"] = "api_account_id";
    /** column name */ InstanceDebugSessions_Select_Column["Id"] = "id";
    /** column name */ InstanceDebugSessions_Select_Column["ServiceName"] = "service_name";
})(InstanceDebugSessions_Select_Column || (InstanceDebugSessions_Select_Column = {}));
export var InstanceDebugSessions_Update_Column;
(function(InstanceDebugSessions_Update_Column) {
    /** column name */ InstanceDebugSessions_Update_Column["ApiAccountId"] = "api_account_id";
    /** column name */ InstanceDebugSessions_Update_Column["Id"] = "id";
    /** column name */ InstanceDebugSessions_Update_Column["ServiceName"] = "service_name";
})(InstanceDebugSessions_Update_Column || (InstanceDebugSessions_Update_Column = {}));
export var InstanceDomains_Constraint;
(function(InstanceDomains_Constraint) {
    /** unique or primary key constraint on columns "id" */ InstanceDomains_Constraint["InstanceDomainsPkey"] = "InstanceDomains_pkey";
})(InstanceDomains_Constraint || (InstanceDomains_Constraint = {}));
export var InstanceDomains_Select_Column;
(function(InstanceDomains_Select_Column) {
    /** column name */ InstanceDomains_Select_Column["DeletedAt"] = "deleted_at";
    /** column name */ InstanceDomains_Select_Column["Domain"] = "domain";
    /** column name */ InstanceDomains_Select_Column["Id"] = "id";
    /** column name */ InstanceDomains_Select_Column["InstanceId"] = "instance_id";
})(InstanceDomains_Select_Column || (InstanceDomains_Select_Column = {}));
export var InstanceDomains_Update_Column;
(function(InstanceDomains_Update_Column) {
    /** column name */ InstanceDomains_Update_Column["DeletedAt"] = "deleted_at";
    /** column name */ InstanceDomains_Update_Column["Domain"] = "domain";
    /** column name */ InstanceDomains_Update_Column["Id"] = "id";
    /** column name */ InstanceDomains_Update_Column["InstanceId"] = "instance_id";
})(InstanceDomains_Update_Column || (InstanceDomains_Update_Column = {}));
export var Instances_Constraint;
(function(Instances_Constraint) {
    /** unique or primary key constraint on columns "id" */ Instances_Constraint["InstancesPkey"] = "Instances_pkey";
})(Instances_Constraint || (Instances_Constraint = {}));
export var Instances_Select_Column;
(function(Instances_Select_Column) {
    /** column name */ Instances_Select_Column["ApiApplicationId"] = "api_application_id";
    /** column name */ Instances_Select_Column["CreatedAt"] = "created_at";
    /** column name */ Instances_Select_Column["Deleted"] = "deleted";
    /** column name */ Instances_Select_Column["DeploymentId"] = "deployment_id";
    /** column name */ Instances_Select_Column["Id"] = "id";
    /** column name */ Instances_Select_Column["Name"] = "name";
    /** column name */ Instances_Select_Column["OmegaId"] = "omega_id";
    /** column name */ Instances_Select_Column["ProjectId"] = "project_id";
    /** column name */ Instances_Select_Column["RegionId"] = "region_id";
    /** column name */ Instances_Select_Column["ServiceName"] = "service_name";
    /** column name */ Instances_Select_Column["UpdatedAt"] = "updated_at";
})(Instances_Select_Column || (Instances_Select_Column = {}));
export var Instances_Select_Column_Instances_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
(function(Instances_Select_Column_Instances_Aggregate_Bool_Exp_Bool_And_Arguments_Columns) {
    /** column name */ Instances_Select_Column_Instances_Aggregate_Bool_Exp_Bool_And_Arguments_Columns["Deleted"] = "deleted";
})(Instances_Select_Column_Instances_Aggregate_Bool_Exp_Bool_And_Arguments_Columns || (Instances_Select_Column_Instances_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {}));
export var Instances_Select_Column_Instances_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
(function(Instances_Select_Column_Instances_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns) {
    /** column name */ Instances_Select_Column_Instances_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns["Deleted"] = "deleted";
})(Instances_Select_Column_Instances_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns || (Instances_Select_Column_Instances_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {}));
export var Instances_Update_Column;
(function(Instances_Update_Column) {
    /** column name */ Instances_Update_Column["ApiApplicationId"] = "api_application_id";
    /** column name */ Instances_Update_Column["CreatedAt"] = "created_at";
    /** column name */ Instances_Update_Column["Deleted"] = "deleted";
    /** column name */ Instances_Update_Column["DeploymentId"] = "deployment_id";
    /** column name */ Instances_Update_Column["Id"] = "id";
    /** column name */ Instances_Update_Column["Name"] = "name";
    /** column name */ Instances_Update_Column["OmegaId"] = "omega_id";
    /** column name */ Instances_Update_Column["ProjectId"] = "project_id";
    /** column name */ Instances_Update_Column["RegionId"] = "region_id";
    /** column name */ Instances_Update_Column["ServiceName"] = "service_name";
    /** column name */ Instances_Update_Column["UpdatedAt"] = "updated_at";
})(Instances_Update_Column || (Instances_Update_Column = {}));
export var Logs_Select_Column;
(function(Logs_Select_Column) {
    /** column name */ Logs_Select_Column["ApiAccountId"] = "api_account_id";
    /** column name */ Logs_Select_Column["ApiApplicationId"] = "api_application_id";
    /** column name */ Logs_Select_Column["Context"] = "context";
    /** column name */ Logs_Select_Column["Id"] = "id";
    /** column name */ Logs_Select_Column["InstanceId"] = "instance_id";
    /** column name */ Logs_Select_Column["LogLevel"] = "log_level";
    /** column name */ Logs_Select_Column["Message"] = "message";
    /** column name */ Logs_Select_Column["SessionId"] = "session_id";
    /** column name */ Logs_Select_Column["SourceId"] = "source_id";
    /** column name */ Logs_Select_Column["SourceType"] = "source_type";
    /** column name */ Logs_Select_Column["Timestamp"] = "timestamp";
})(Logs_Select_Column || (Logs_Select_Column = {}));
export var PackageAcl_Constraint;
(function(PackageAcl_Constraint) {
    /** unique or primary key constraint on columns "api_account_id", "package_id" */ PackageAcl_Constraint["PackageAclApiAccountIdAndPackageId"] = "PackageACL_api_account_id_and_package_id";
    /** unique or primary key constraint on columns "id" */ PackageAcl_Constraint["PackageAclPkey"] = "PackageACL_pkey";
})(PackageAcl_Constraint || (PackageAcl_Constraint = {}));
export var PackageAcl_Select_Column;
(function(PackageAcl_Select_Column) {
    /** column name */ PackageAcl_Select_Column["ApiAccountId"] = "api_account_id";
    /** column name */ PackageAcl_Select_Column["Id"] = "id";
    /** column name */ PackageAcl_Select_Column["PackageId"] = "package_id";
})(PackageAcl_Select_Column || (PackageAcl_Select_Column = {}));
export var PackageAcl_Update_Column;
(function(PackageAcl_Update_Column) {
    /** column name */ PackageAcl_Update_Column["ApiAccountId"] = "api_account_id";
    /** column name */ PackageAcl_Update_Column["Id"] = "id";
    /** column name */ PackageAcl_Update_Column["PackageId"] = "package_id";
})(PackageAcl_Update_Column || (PackageAcl_Update_Column = {}));
export var PackageStatus_Constraint;
(function(PackageStatus_Constraint) {
    /** unique or primary key constraint on columns "value" */ PackageStatus_Constraint["PackageStatusPkey"] = "PackageStatus_pkey";
})(PackageStatus_Constraint || (PackageStatus_Constraint = {}));
export var PackageStatus_Enum;
(function(PackageStatus_Enum) {
    /** image is being built for package */ PackageStatus_Enum["Building"] = "building";
    /** image has been built */ PackageStatus_Enum["Completed"] = "completed";
    /** image failed to build */ PackageStatus_Enum["Failed"] = "failed";
    /** package is waiting to be built */ PackageStatus_Enum["Pending"] = "pending";
})(PackageStatus_Enum || (PackageStatus_Enum = {}));
export var PackageStatus_Select_Column;
(function(PackageStatus_Select_Column) {
    /** column name */ PackageStatus_Select_Column["Description"] = "description";
    /** column name */ PackageStatus_Select_Column["Value"] = "value";
})(PackageStatus_Select_Column || (PackageStatus_Select_Column = {}));
export var PackageStatus_Update_Column;
(function(PackageStatus_Update_Column) {
    /** column name */ PackageStatus_Update_Column["Description"] = "description";
    /** column name */ PackageStatus_Update_Column["Value"] = "value";
})(PackageStatus_Update_Column || (PackageStatus_Update_Column = {}));
export var Packages_Constraint;
(function(Packages_Constraint) {
    /** unique or primary key constraint on columns "id" */ Packages_Constraint["UploadsPkey"] = "Uploads_pkey";
})(Packages_Constraint || (Packages_Constraint = {}));
export var Packages_Select_Column;
(function(Packages_Select_Column) {
    /** column name */ Packages_Select_Column["ApiAccountId"] = "api_account_id";
    /** column name */ Packages_Select_Column["CapMessages"] = "cap_messages";
    /** column name */ Packages_Select_Column["CapNetwork"] = "cap_network";
    /** column name */ Packages_Select_Column["CapRtc"] = "cap_rtc";
    /** column name */ Packages_Select_Column["CapVerify"] = "cap_verify";
    /** column name */ Packages_Select_Column["CapVideo"] = "cap_video";
    /** column name */ Packages_Select_Column["CapVoice"] = "cap_voice";
    /** column name */ Packages_Select_Column["CreatedAt"] = "created_at";
    /** column name */ Packages_Select_Column["Entrypoint"] = "entrypoint";
    /** column name */ Packages_Select_Column["Id"] = "id";
    /** column name */ Packages_Select_Column["ImageName"] = "image_name";
    /** column name */ Packages_Select_Column["Messaging"] = "messaging";
    /** column name */ Packages_Select_Column["Path"] = "path";
    /** column name */ Packages_Select_Column["Rtc"] = "rtc";
    /** column name */ Packages_Select_Column["RuntimeId"] = "runtime_id";
    /** column name */ Packages_Select_Column["Status"] = "status";
    /** column name */ Packages_Select_Column["Voice"] = "voice";
})(Packages_Select_Column || (Packages_Select_Column = {}));
export var Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
(function(Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns) {
    /** column name */ Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns["Messaging"] = "messaging";
    /** column name */ Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns["Rtc"] = "rtc";
    /** column name */ Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns["Voice"] = "voice";
})(Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns || (Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {}));
export var Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
(function(Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns) {
    /** column name */ Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns["Messaging"] = "messaging";
    /** column name */ Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns["Rtc"] = "rtc";
    /** column name */ Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns["Voice"] = "voice";
})(Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns || (Packages_Select_Column_Packages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {}));
export var Packages_Update_Column;
(function(Packages_Update_Column) {
    /** column name */ Packages_Update_Column["ApiAccountId"] = "api_account_id";
    /** column name */ Packages_Update_Column["CapMessages"] = "cap_messages";
    /** column name */ Packages_Update_Column["CapNetwork"] = "cap_network";
    /** column name */ Packages_Update_Column["CapRtc"] = "cap_rtc";
    /** column name */ Packages_Update_Column["CapVerify"] = "cap_verify";
    /** column name */ Packages_Update_Column["CapVideo"] = "cap_video";
    /** column name */ Packages_Update_Column["CapVoice"] = "cap_voice";
    /** column name */ Packages_Update_Column["CreatedAt"] = "created_at";
    /** column name */ Packages_Update_Column["Entrypoint"] = "entrypoint";
    /** column name */ Packages_Update_Column["Id"] = "id";
    /** column name */ Packages_Update_Column["ImageName"] = "image_name";
    /** column name */ Packages_Update_Column["Messaging"] = "messaging";
    /** column name */ Packages_Update_Column["Path"] = "path";
    /** column name */ Packages_Update_Column["Rtc"] = "rtc";
    /** column name */ Packages_Update_Column["RuntimeId"] = "runtime_id";
    /** column name */ Packages_Update_Column["Status"] = "status";
    /** column name */ Packages_Update_Column["Voice"] = "voice";
})(Packages_Update_Column || (Packages_Update_Column = {}));
export var ProductProgrammingLanguage_Constraint;
(function(ProductProgrammingLanguage_Constraint) {
    /** unique or primary key constraint on columns "value" */ ProductProgrammingLanguage_Constraint["ProductProgrammingLanguagePkey"] = "ProductProgrammingLanguage_pkey";
})(ProductProgrammingLanguage_Constraint || (ProductProgrammingLanguage_Constraint = {}));
export var ProductProgrammingLanguage_Enum;
(function(ProductProgrammingLanguage_Enum) {
    /** Go */ ProductProgrammingLanguage_Enum["Go"] = "Go";
    /** Java */ ProductProgrammingLanguage_Enum["Java"] = "Java";
    /** NodeJS */ ProductProgrammingLanguage_Enum["NodeJs"] = "NodeJS";
    /** PHP */ ProductProgrammingLanguage_Enum["Php"] = "PHP";
    /** Python */ ProductProgrammingLanguage_Enum["Python"] = "Python";
})(ProductProgrammingLanguage_Enum || (ProductProgrammingLanguage_Enum = {}));
export var ProductProgrammingLanguage_Select_Column;
(function(ProductProgrammingLanguage_Select_Column) {
    /** column name */ ProductProgrammingLanguage_Select_Column["Description"] = "description";
    /** column name */ ProductProgrammingLanguage_Select_Column["Value"] = "value";
})(ProductProgrammingLanguage_Select_Column || (ProductProgrammingLanguage_Select_Column = {}));
export var ProductProgrammingLanguage_Update_Column;
(function(ProductProgrammingLanguage_Update_Column) {
    /** column name */ ProductProgrammingLanguage_Update_Column["Description"] = "description";
    /** column name */ ProductProgrammingLanguage_Update_Column["Value"] = "value";
})(ProductProgrammingLanguage_Update_Column || (ProductProgrammingLanguage_Update_Column = {}));
export var ProductStatus_Constraint;
(function(ProductStatus_Constraint) {
    /** unique or primary key constraint on columns "value" */ ProductStatus_Constraint["ProductStatusPkey1"] = "ProductStatus_pkey1";
})(ProductStatus_Constraint || (ProductStatus_Constraint = {}));
export var ProductStatus_Enum;
(function(ProductStatus_Enum) {
    /** approved */ ProductStatus_Enum["Approved"] = "approved";
    /** unapproved */ ProductStatus_Enum["Unapproved"] = "unapproved";
})(ProductStatus_Enum || (ProductStatus_Enum = {}));
export var ProductStatus_Select_Column;
(function(ProductStatus_Select_Column) {
    /** column name */ ProductStatus_Select_Column["Description"] = "description";
    /** column name */ ProductStatus_Select_Column["Value"] = "value";
})(ProductStatus_Select_Column || (ProductStatus_Select_Column = {}));
export var ProductStatus_Update_Column;
(function(ProductStatus_Update_Column) {
    /** column name */ ProductStatus_Update_Column["Description"] = "description";
    /** column name */ ProductStatus_Update_Column["Value"] = "value";
})(ProductStatus_Update_Column || (ProductStatus_Update_Column = {}));
export var ProductType_Constraint;
(function(ProductType_Constraint) {
    /** unique or primary key constraint on columns "value" */ ProductType_Constraint["ProductTypePkey"] = "ProductType_pkey";
})(ProductType_Constraint || (ProductType_Constraint = {}));
export var ProductType_Enum;
(function(ProductType_Enum) {
    /** dev */ ProductType_Enum["Dev"] = "dev";
    /** private */ ProductType_Enum["Private"] = "private";
    /** public */ ProductType_Enum["Public"] = "public";
    /** unlisted */ ProductType_Enum["Unlisted"] = "unlisted";
})(ProductType_Enum || (ProductType_Enum = {}));
export var ProductType_Select_Column;
(function(ProductType_Select_Column) {
    /** column name */ ProductType_Select_Column["Description"] = "description";
    /** column name */ ProductType_Select_Column["Value"] = "value";
})(ProductType_Select_Column || (ProductType_Select_Column = {}));
export var ProductType_Update_Column;
(function(ProductType_Update_Column) {
    /** column name */ ProductType_Update_Column["Description"] = "description";
    /** column name */ ProductType_Update_Column["Value"] = "value";
})(ProductType_Update_Column || (ProductType_Update_Column = {}));
export var ProductVersionStatus_Constraint;
(function(ProductVersionStatus_Constraint) {
    /** unique or primary key constraint on columns "value" */ ProductVersionStatus_Constraint["ProductStatusPkey"] = "ProductStatus_pkey";
})(ProductVersionStatus_Constraint || (ProductVersionStatus_Constraint = {}));
export var ProductVersionStatus_Enum;
(function(ProductVersionStatus_Enum) {
    /** product version has been approved */ ProductVersionStatus_Enum["Approved"] = "approved";
    /** product version was declined */ ProductVersionStatus_Enum["Declined"] = "declined";
    /** source code is being reviewed by a human */ ProductVersionStatus_Enum["InManualReview"] = "in_manual_review";
    /** product version is live on the marketplace and ready to be installed */ ProductVersionStatus_Enum["Live"] = "live";
    /** product version has been submitted for review */ ProductVersionStatus_Enum["Submitted"] = "submitted";
    /** waiting for owner to submit version for review */ ProductVersionStatus_Enum["WaitingForSubmission"] = "waiting_for_submission";
    /** source code is waiting to be reviewed by a human */ ProductVersionStatus_Enum["WaitingManualReview"] = "waiting_manual_review";
})(ProductVersionStatus_Enum || (ProductVersionStatus_Enum = {}));
export var ProductVersionStatus_Select_Column;
(function(ProductVersionStatus_Select_Column) {
    /** column name */ ProductVersionStatus_Select_Column["Description"] = "description";
    /** column name */ ProductVersionStatus_Select_Column["Value"] = "value";
})(ProductVersionStatus_Select_Column || (ProductVersionStatus_Select_Column = {}));
export var ProductVersionStatus_Update_Column;
(function(ProductVersionStatus_Update_Column) {
    /** column name */ ProductVersionStatus_Update_Column["Description"] = "description";
    /** column name */ ProductVersionStatus_Update_Column["Value"] = "value";
})(ProductVersionStatus_Update_Column || (ProductVersionStatus_Update_Column = {}));
export var ProductVersions_Constraint;
(function(ProductVersions_Constraint) {
    /** unique or primary key constraint on columns "id" */ ProductVersions_Constraint["ProductVersionsPkey"] = "ProductVersions_pkey";
})(ProductVersions_Constraint || (ProductVersions_Constraint = {}));
export var ProductVersions_Select_Column;
(function(ProductVersions_Select_Column) {
    /** column name */ ProductVersions_Select_Column["CodeTemplateEnabled"] = "code_template_enabled";
    /** column name */ ProductVersions_Select_Column["CreatedAt"] = "created_at";
    /** column name */ ProductVersions_Select_Column["DefaultConfiguration"] = "default_configuration";
    /** column name */ ProductVersions_Select_Column["DeployEnabled"] = "deploy_enabled";
    /** column name */ ProductVersions_Select_Column["Documentation"] = "documentation";
    /** column name */ ProductVersions_Select_Column["Icon"] = "icon";
    /** column name */ ProductVersions_Select_Column["Id"] = "id";
    /** column name */ ProductVersions_Select_Column["LongDescription"] = "long_description";
    /** column name */ ProductVersions_Select_Column["PackageId"] = "package_id";
    /** column name */ ProductVersions_Select_Column["ProductId"] = "product_id";
    /** column name */ ProductVersions_Select_Column["ReleaseNotes"] = "release_notes";
    /** column name */ ProductVersions_Select_Column["Screenshots"] = "screenshots";
    /** column name */ ProductVersions_Select_Column["SetupConfiguration"] = "setup_configuration";
    /** column name */ ProductVersions_Select_Column["ShortDescription"] = "short_description";
    /** column name */ ProductVersions_Select_Column["SourceCode"] = "source_code";
    /** column name */ ProductVersions_Select_Column["Status"] = "status";
    /** column name */ ProductVersions_Select_Column["Type"] = "type";
    /** column name */ ProductVersions_Select_Column["UpdatedAt"] = "updated_at";
    /** column name */ ProductVersions_Select_Column["Version"] = "version";
})(ProductVersions_Select_Column || (ProductVersions_Select_Column = {}));
export var ProductVersions_Select_Column_ProductVersions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
(function(ProductVersions_Select_Column_ProductVersions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns) {
    /** column name */ ProductVersions_Select_Column_ProductVersions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns["CodeTemplateEnabled"] = "code_template_enabled";
    /** column name */ ProductVersions_Select_Column_ProductVersions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns["DeployEnabled"] = "deploy_enabled";
})(ProductVersions_Select_Column_ProductVersions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns || (ProductVersions_Select_Column_ProductVersions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {}));
export var ProductVersions_Select_Column_ProductVersions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
(function(ProductVersions_Select_Column_ProductVersions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns) {
    /** column name */ ProductVersions_Select_Column_ProductVersions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns["CodeTemplateEnabled"] = "code_template_enabled";
    /** column name */ ProductVersions_Select_Column_ProductVersions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns["DeployEnabled"] = "deploy_enabled";
})(ProductVersions_Select_Column_ProductVersions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns || (ProductVersions_Select_Column_ProductVersions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {}));
export var ProductVersions_Update_Column;
(function(ProductVersions_Update_Column) {
    /** column name */ ProductVersions_Update_Column["CodeTemplateEnabled"] = "code_template_enabled";
    /** column name */ ProductVersions_Update_Column["CreatedAt"] = "created_at";
    /** column name */ ProductVersions_Update_Column["DefaultConfiguration"] = "default_configuration";
    /** column name */ ProductVersions_Update_Column["DeployEnabled"] = "deploy_enabled";
    /** column name */ ProductVersions_Update_Column["Documentation"] = "documentation";
    /** column name */ ProductVersions_Update_Column["Icon"] = "icon";
    /** column name */ ProductVersions_Update_Column["Id"] = "id";
    /** column name */ ProductVersions_Update_Column["LongDescription"] = "long_description";
    /** column name */ ProductVersions_Update_Column["PackageId"] = "package_id";
    /** column name */ ProductVersions_Update_Column["ProductId"] = "product_id";
    /** column name */ ProductVersions_Update_Column["ReleaseNotes"] = "release_notes";
    /** column name */ ProductVersions_Update_Column["Screenshots"] = "screenshots";
    /** column name */ ProductVersions_Update_Column["SetupConfiguration"] = "setup_configuration";
    /** column name */ ProductVersions_Update_Column["ShortDescription"] = "short_description";
    /** column name */ ProductVersions_Update_Column["SourceCode"] = "source_code";
    /** column name */ ProductVersions_Update_Column["Status"] = "status";
    /** column name */ ProductVersions_Update_Column["Type"] = "type";
    /** column name */ ProductVersions_Update_Column["UpdatedAt"] = "updated_at";
    /** column name */ ProductVersions_Update_Column["Version"] = "version";
})(ProductVersions_Update_Column || (ProductVersions_Update_Column = {}));
export var Products_Constraint;
(function(Products_Constraint) {
    /** unique or primary key constraint on columns "id" */ Products_Constraint["ProductsPkey"] = "Products_pkey";
})(Products_Constraint || (Products_Constraint = {}));
export var Products_Select_Column;
(function(Products_Select_Column) {
    /** column name */ Products_Select_Column["ActiveVersionId"] = "active_version_id";
    /** column name */ Products_Select_Column["CreatedAt"] = "created_at";
    /** column name */ Products_Select_Column["DeletedAt"] = "deleted_at";
    /** column name */ Products_Select_Column["EnrollTierId"] = "enroll_tier_id";
    /** column name */ Products_Select_Column["Hidden"] = "hidden";
    /** column name */ Products_Select_Column["Id"] = "id";
    /** column name */ Products_Select_Column["Name"] = "name";
    /** column name */ Products_Select_Column["Owner"] = "owner";
    /** column name */ Products_Select_Column["OwnerName"] = "owner_name";
    /** column name */ Products_Select_Column["Priority"] = "priority";
    /** column name */ Products_Select_Column["ProgrammingLanguage"] = "programming_language";
    /** column name */ Products_Select_Column["Status"] = "status";
    /** column name */ Products_Select_Column["Type"] = "type";
    /** column name */ Products_Select_Column["UpdatedAt"] = "updated_at";
})(Products_Select_Column || (Products_Select_Column = {}));
export var Products_Select_Column_Products_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
(function(Products_Select_Column_Products_Aggregate_Bool_Exp_Bool_And_Arguments_Columns) {
    /** column name */ Products_Select_Column_Products_Aggregate_Bool_Exp_Bool_And_Arguments_Columns["Hidden"] = "hidden";
})(Products_Select_Column_Products_Aggregate_Bool_Exp_Bool_And_Arguments_Columns || (Products_Select_Column_Products_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {}));
export var Products_Select_Column_Products_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
(function(Products_Select_Column_Products_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns) {
    /** column name */ Products_Select_Column_Products_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns["Hidden"] = "hidden";
})(Products_Select_Column_Products_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns || (Products_Select_Column_Products_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {}));
export var Products_Update_Column;
(function(Products_Update_Column) {
    /** column name */ Products_Update_Column["ActiveVersionId"] = "active_version_id";
    /** column name */ Products_Update_Column["CreatedAt"] = "created_at";
    /** column name */ Products_Update_Column["DeletedAt"] = "deleted_at";
    /** column name */ Products_Update_Column["EnrollTierId"] = "enroll_tier_id";
    /** column name */ Products_Update_Column["Hidden"] = "hidden";
    /** column name */ Products_Update_Column["Id"] = "id";
    /** column name */ Products_Update_Column["Name"] = "name";
    /** column name */ Products_Update_Column["Owner"] = "owner";
    /** column name */ Products_Update_Column["OwnerName"] = "owner_name";
    /** column name */ Products_Update_Column["Priority"] = "priority";
    /** column name */ Products_Update_Column["ProgrammingLanguage"] = "programming_language";
    /** column name */ Products_Update_Column["Status"] = "status";
    /** column name */ Products_Update_Column["Type"] = "type";
    /** column name */ Products_Update_Column["UpdatedAt"] = "updated_at";
})(Products_Update_Column || (Products_Update_Column = {}));
export var ProjectOrigin_Constraint;
(function(ProjectOrigin_Constraint) {
    /** unique or primary key constraint on columns "value" */ ProjectOrigin_Constraint["ProjectOriginPkey"] = "ProjectOrigin_pkey";
})(ProjectOrigin_Constraint || (ProjectOrigin_Constraint = {}));
export var ProjectOrigin_Enum;
(function(ProjectOrigin_Enum) {
    /** project was installed from marketplace */ ProjectOrigin_Enum["Marketplace"] = "marketplace";
    /** project originated from owner and has access for source code */ ProjectOrigin_Enum["Owner"] = "owner";
})(ProjectOrigin_Enum || (ProjectOrigin_Enum = {}));
export var ProjectOrigin_Select_Column;
(function(ProjectOrigin_Select_Column) {
    /** column name */ ProjectOrigin_Select_Column["Description"] = "description";
    /** column name */ ProjectOrigin_Select_Column["Value"] = "value";
})(ProjectOrigin_Select_Column || (ProjectOrigin_Select_Column = {}));
export var ProjectOrigin_Update_Column;
(function(ProjectOrigin_Update_Column) {
    /** column name */ ProjectOrigin_Update_Column["Description"] = "description";
    /** column name */ ProjectOrigin_Update_Column["Value"] = "value";
})(ProjectOrigin_Update_Column || (ProjectOrigin_Update_Column = {}));
export var ProjectProductVersions_Select_Column;
(function(ProjectProductVersions_Select_Column) {
    /** column name */ ProjectProductVersions_Select_Column["ProductId"] = "product_id";
    /** column name */ ProjectProductVersions_Select_Column["ProductVersionId"] = "product_version_id";
    /** column name */ ProjectProductVersions_Select_Column["ProjectId"] = "project_id";
})(ProjectProductVersions_Select_Column || (ProjectProductVersions_Select_Column = {}));
export var Projects_Constraint;
(function(Projects_Constraint) {
    /** unique or primary key constraint on columns "id" */ Projects_Constraint["ApplicationsPkey"] = "Applications_pkey";
})(Projects_Constraint || (Projects_Constraint = {}));
export var Projects_Select_Column;
(function(Projects_Select_Column) {
    /** column name */ Projects_Select_Column["ApiAccountId"] = "api_account_id";
    /** column name */ Projects_Select_Column["CreatedAt"] = "created_at";
    /** column name */ Projects_Select_Column["Deleted"] = "deleted";
    /** column name */ Projects_Select_Column["Id"] = "id";
    /** column name */ Projects_Select_Column["Name"] = "name";
    /** column name */ Projects_Select_Column["Origin"] = "origin";
    /** column name */ Projects_Select_Column["ProductId"] = "product_id";
    /** column name */ Projects_Select_Column["UpdatedAt"] = "updated_at";
})(Projects_Select_Column || (Projects_Select_Column = {}));
export var Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
(function(Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_And_Arguments_Columns) {
    /** column name */ Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_And_Arguments_Columns["Deleted"] = "deleted";
})(Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_And_Arguments_Columns || (Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {}));
export var Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
(function(Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns) {
    /** column name */ Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns["Deleted"] = "deleted";
})(Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns || (Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {}));
export var Projects_Update_Column;
(function(Projects_Update_Column) {
    /** column name */ Projects_Update_Column["ApiAccountId"] = "api_account_id";
    /** column name */ Projects_Update_Column["CreatedAt"] = "created_at";
    /** column name */ Projects_Update_Column["Deleted"] = "deleted";
    /** column name */ Projects_Update_Column["Id"] = "id";
    /** column name */ Projects_Update_Column["Name"] = "name";
    /** column name */ Projects_Update_Column["Origin"] = "origin";
    /** column name */ Projects_Update_Column["ProductId"] = "product_id";
    /** column name */ Projects_Update_Column["UpdatedAt"] = "updated_at";
})(Projects_Update_Column || (Projects_Update_Column = {}));
export var Regions_Constraint;
(function(Regions_Constraint) {
    /** unique or primary key constraint on columns "id" */ Regions_Constraint["RegionsPkey"] = "Regions_pkey";
})(Regions_Constraint || (Regions_Constraint = {}));
export var Regions_Select_Column;
(function(Regions_Select_Column) {
    /** column name */ Regions_Select_Column["Alias"] = "alias";
    /** column name */ Regions_Select_Column["AssetsApiUrl"] = "assets_api_url";
    /** column name */ Regions_Select_Column["CreatedAt"] = "created_at";
    /** column name */ Regions_Select_Column["DebuggerApiUrl"] = "debugger_api_url";
    /** column name */ Regions_Select_Column["DebuggerUrlScheme"] = "debugger_url_scheme";
    /** column name */ Regions_Select_Column["Default"] = "default";
    /** column name */ Regions_Select_Column["DeploymentApiUrl"] = "deployment_api_url";
    /** column name */ Regions_Select_Column["Enabled"] = "enabled";
    /** column name */ Regions_Select_Column["EndpointUrlScheme"] = "endpoint_url_scheme";
    /** column name */ Regions_Select_Column["HostTemplate"] = "host_template";
    /** column name */ Regions_Select_Column["Id"] = "id";
    /** column name */ Regions_Select_Column["MarketplaceApiUrl"] = "marketplace_api_url";
    /** column name */ Regions_Select_Column["MetadataUrl"] = "metadata_url";
    /** column name */ Regions_Select_Column["MetadataUrlUi"] = "metadata_url_ui";
    /** column name */ Regions_Select_Column["Name"] = "name";
    /** column name */ Regions_Select_Column["UpdatedAt"] = "updated_at";
})(Regions_Select_Column || (Regions_Select_Column = {}));
export var Regions_Update_Column;
(function(Regions_Update_Column) {
    /** column name */ Regions_Update_Column["Alias"] = "alias";
    /** column name */ Regions_Update_Column["AssetsApiUrl"] = "assets_api_url";
    /** column name */ Regions_Update_Column["CreatedAt"] = "created_at";
    /** column name */ Regions_Update_Column["DebuggerApiUrl"] = "debugger_api_url";
    /** column name */ Regions_Update_Column["DebuggerUrlScheme"] = "debugger_url_scheme";
    /** column name */ Regions_Update_Column["Default"] = "default";
    /** column name */ Regions_Update_Column["DeploymentApiUrl"] = "deployment_api_url";
    /** column name */ Regions_Update_Column["Enabled"] = "enabled";
    /** column name */ Regions_Update_Column["EndpointUrlScheme"] = "endpoint_url_scheme";
    /** column name */ Regions_Update_Column["HostTemplate"] = "host_template";
    /** column name */ Regions_Update_Column["Id"] = "id";
    /** column name */ Regions_Update_Column["MarketplaceApiUrl"] = "marketplace_api_url";
    /** column name */ Regions_Update_Column["MetadataUrl"] = "metadata_url";
    /** column name */ Regions_Update_Column["MetadataUrlUi"] = "metadata_url_ui";
    /** column name */ Regions_Update_Column["Name"] = "name";
    /** column name */ Regions_Update_Column["UpdatedAt"] = "updated_at";
})(Regions_Update_Column || (Regions_Update_Column = {}));
export var Runtimes_Constraint;
(function(Runtimes_Constraint) {
    /** unique or primary key constraint on columns "name" */ Runtimes_Constraint["RuntimesNameKey"] = "Runtimes_name_key";
    /** unique or primary key constraint on columns "id" */ Runtimes_Constraint["RuntimesPkey"] = "Runtimes_pkey";
})(Runtimes_Constraint || (Runtimes_Constraint = {}));
export var Runtimes_Select_Column;
(function(Runtimes_Select_Column) {
    /** column name */ Runtimes_Select_Column["ApiVersion"] = "api_version";
    /** column name */ Runtimes_Select_Column["Comments"] = "comments";
    /** column name */ Runtimes_Select_Column["ContainerImage"] = "container_image";
    /** column name */ Runtimes_Select_Column["CreatedAt"] = "created_at";
    /** column name */ Runtimes_Select_Column["DebugCommandConfig"] = "debug_command_config";
    /** column name */ Runtimes_Select_Column["DebugHandlerPath"] = "debug_handler_path";
    /** column name */ Runtimes_Select_Column["DebuggerPackage"] = "debugger_package";
    /** column name */ Runtimes_Select_Column["Enabled"] = "enabled";
    /** column name */ Runtimes_Select_Column["Id"] = "id";
    /** column name */ Runtimes_Select_Column["Language"] = "language";
    /** column name */ Runtimes_Select_Column["Name"] = "name";
    /** column name */ Runtimes_Select_Column["NetworkPort"] = "network_port";
    /** column name */ Runtimes_Select_Column["UpdatedAt"] = "updated_at";
    /** column name */ Runtimes_Select_Column["Workdir"] = "workdir";
})(Runtimes_Select_Column || (Runtimes_Select_Column = {}));
export var Runtimes_Update_Column;
(function(Runtimes_Update_Column) {
    /** column name */ Runtimes_Update_Column["ApiVersion"] = "api_version";
    /** column name */ Runtimes_Update_Column["Comments"] = "comments";
    /** column name */ Runtimes_Update_Column["ContainerImage"] = "container_image";
    /** column name */ Runtimes_Update_Column["CreatedAt"] = "created_at";
    /** column name */ Runtimes_Update_Column["DebugCommandConfig"] = "debug_command_config";
    /** column name */ Runtimes_Update_Column["DebugHandlerPath"] = "debug_handler_path";
    /** column name */ Runtimes_Update_Column["DebuggerPackage"] = "debugger_package";
    /** column name */ Runtimes_Update_Column["Enabled"] = "enabled";
    /** column name */ Runtimes_Update_Column["Id"] = "id";
    /** column name */ Runtimes_Update_Column["Language"] = "language";
    /** column name */ Runtimes_Update_Column["Name"] = "name";
    /** column name */ Runtimes_Update_Column["NetworkPort"] = "network_port";
    /** column name */ Runtimes_Update_Column["UpdatedAt"] = "updated_at";
    /** column name */ Runtimes_Update_Column["Workdir"] = "workdir";
})(Runtimes_Update_Column || (Runtimes_Update_Column = {}));
export var Tags_Constraint;
(function(Tags_Constraint) {
    /** unique or primary key constraint on columns "name" */ Tags_Constraint["TagsNameKey"] = "Tags_name_key";
    /** unique or primary key constraint on columns "name" */ Tags_Constraint["TagsPkey"] = "Tags_pkey";
})(Tags_Constraint || (Tags_Constraint = {}));
export var Tags_Select_Column;
(function(Tags_Select_Column) {
    /** column name */ Tags_Select_Column["Name"] = "name";
})(Tags_Select_Column || (Tags_Select_Column = {}));
export var Tags_Update_Column;
(function(Tags_Update_Column) {
    /** column name */ Tags_Update_Column["Name"] = "name";
})(Tags_Update_Column || (Tags_Update_Column = {}));
export var TierLimits_Constraint;
(function(TierLimits_Constraint) {
    /** unique or primary key constraint on columns "id" */ TierLimits_Constraint["TierLimitsPkey"] = "TierLimits_pkey";
    /** unique or primary key constraint on columns "target", "tier_id", "name" */ TierLimits_Constraint["TierLimitsTierIdNameTargetKey"] = "TierLimits_tier_id_name_target_key";
})(TierLimits_Constraint || (TierLimits_Constraint = {}));
export var TierLimits_Select_Column;
(function(TierLimits_Select_Column) {
    /** column name */ TierLimits_Select_Column["Allowance"] = "allowance";
    /** column name */ TierLimits_Select_Column["Id"] = "id";
    /** column name */ TierLimits_Select_Column["Name"] = "name";
    /** column name */ TierLimits_Select_Column["Price"] = "price";
    /** column name */ TierLimits_Select_Column["Target"] = "target";
    /** column name */ TierLimits_Select_Column["TierId"] = "tier_id";
    /** column name */ TierLimits_Select_Column["UsageType"] = "usage_type";
    /** column name */ TierLimits_Select_Column["Value"] = "value";
})(TierLimits_Select_Column || (TierLimits_Select_Column = {}));
export var TierLimits_Update_Column;
(function(TierLimits_Update_Column) {
    /** column name */ TierLimits_Update_Column["Allowance"] = "allowance";
    /** column name */ TierLimits_Update_Column["Id"] = "id";
    /** column name */ TierLimits_Update_Column["Name"] = "name";
    /** column name */ TierLimits_Update_Column["Price"] = "price";
    /** column name */ TierLimits_Update_Column["Target"] = "target";
    /** column name */ TierLimits_Update_Column["TierId"] = "tier_id";
    /** column name */ TierLimits_Update_Column["UsageType"] = "usage_type";
    /** column name */ TierLimits_Update_Column["Value"] = "value";
})(TierLimits_Update_Column || (TierLimits_Update_Column = {}));
export var TiersConfiguration_Constraint;
(function(TiersConfiguration_Constraint) {
    /** unique or primary key constraint on columns "tier_id", "name" */ TiersConfiguration_Constraint["TiersConfigurationNameTierIdKey"] = "TiersConfiguration_name_tier_id_key";
    /** unique or primary key constraint on columns "id" */ TiersConfiguration_Constraint["TiersConfigurationPkey"] = "TiersConfiguration_pkey";
})(TiersConfiguration_Constraint || (TiersConfiguration_Constraint = {}));
export var TiersConfiguration_Select_Column;
(function(TiersConfiguration_Select_Column) {
    /** column name */ TiersConfiguration_Select_Column["Allowance"] = "allowance";
    /** column name */ TiersConfiguration_Select_Column["Id"] = "id";
    /** column name */ TiersConfiguration_Select_Column["Name"] = "name";
    /** column name */ TiersConfiguration_Select_Column["Price"] = "price";
    /** column name */ TiersConfiguration_Select_Column["TierId"] = "tier_id";
})(TiersConfiguration_Select_Column || (TiersConfiguration_Select_Column = {}));
export var TiersConfiguration_Update_Column;
(function(TiersConfiguration_Update_Column) {
    /** column name */ TiersConfiguration_Update_Column["Allowance"] = "allowance";
    /** column name */ TiersConfiguration_Update_Column["Id"] = "id";
    /** column name */ TiersConfiguration_Update_Column["Name"] = "name";
    /** column name */ TiersConfiguration_Update_Column["Price"] = "price";
    /** column name */ TiersConfiguration_Update_Column["TierId"] = "tier_id";
})(TiersConfiguration_Update_Column || (TiersConfiguration_Update_Column = {}));
export var Tiers_Constraint;
(function(Tiers_Constraint) {
    /** unique or primary key constraint on columns "name" */ Tiers_Constraint["TiersNameKey"] = "Tiers_name_key";
    /** unique or primary key constraint on columns "id" */ Tiers_Constraint["TiersPkey"] = "Tiers_pkey";
    /** unique or primary key constraint on columns "product_id" */ Tiers_Constraint["TiersSubscriptionIdKey"] = "Tiers_subscription_id_key";
})(Tiers_Constraint || (Tiers_Constraint = {}));
export var Tiers_Select_Column;
(function(Tiers_Select_Column) {
    /** column name */ Tiers_Select_Column["Id"] = "id";
    /** column name */ Tiers_Select_Column["IsDefault"] = "is_default";
    /** column name */ Tiers_Select_Column["Name"] = "name";
    /** column name */ Tiers_Select_Column["ProductId"] = "product_id";
})(Tiers_Select_Column || (Tiers_Select_Column = {}));
export var Tiers_Update_Column;
(function(Tiers_Update_Column) {
    /** column name */ Tiers_Update_Column["Id"] = "id";
    /** column name */ Tiers_Update_Column["IsDefault"] = "is_default";
    /** column name */ Tiers_Update_Column["Name"] = "name";
    /** column name */ Tiers_Update_Column["ProductId"] = "product_id";
})(Tiers_Update_Column || (Tiers_Update_Column = {}));
export var VersionTag_Constraint;
(function(VersionTag_Constraint) {
    /** unique or primary key constraint on columns "tag", "version_id" */ VersionTag_Constraint["ProductTagPkey"] = "ProductTag_pkey";
    /** unique or primary key constraint on columns "tag", "version_id" */ VersionTag_Constraint["ProductTagProductIdTagIdKey"] = "ProductTag_product_id_tag_id_key";
})(VersionTag_Constraint || (VersionTag_Constraint = {}));
export var VersionTag_Select_Column;
(function(VersionTag_Select_Column) {
    /** column name */ VersionTag_Select_Column["Tag"] = "tag";
    /** column name */ VersionTag_Select_Column["VersionId"] = "version_id";
})(VersionTag_Select_Column || (VersionTag_Select_Column = {}));
export var VersionTag_Update_Column;
(function(VersionTag_Update_Column) {
    /** column name */ VersionTag_Update_Column["Tag"] = "tag";
    /** column name */ VersionTag_Update_Column["VersionId"] = "version_id";
})(VersionTag_Update_Column || (VersionTag_Update_Column = {}));
export var WorkspaceAcl_Constraint;
(function(WorkspaceAcl_Constraint) {
    /** unique or primary key constraint on columns "id" */ WorkspaceAcl_Constraint["WorkspaceAclPkey"] = "WorkspaceACL_pkey";
})(WorkspaceAcl_Constraint || (WorkspaceAcl_Constraint = {}));
export var WorkspaceAcl_Select_Column;
(function(WorkspaceAcl_Select_Column) {
    /** column name */ WorkspaceAcl_Select_Column["Email"] = "email";
    /** column name */ WorkspaceAcl_Select_Column["Id"] = "id";
    /** column name */ WorkspaceAcl_Select_Column["Name"] = "name";
    /** column name */ WorkspaceAcl_Select_Column["WorkspaceId"] = "workspace_id";
})(WorkspaceAcl_Select_Column || (WorkspaceAcl_Select_Column = {}));
export var WorkspaceAcl_Update_Column;
(function(WorkspaceAcl_Update_Column) {
    /** column name */ WorkspaceAcl_Update_Column["Email"] = "email";
    /** column name */ WorkspaceAcl_Update_Column["Id"] = "id";
    /** column name */ WorkspaceAcl_Update_Column["Name"] = "name";
    /** column name */ WorkspaceAcl_Update_Column["WorkspaceId"] = "workspace_id";
})(WorkspaceAcl_Update_Column || (WorkspaceAcl_Update_Column = {}));
export var Workspaces_Constraint;
(function(Workspaces_Constraint) {
    /** unique or primary key constraint on columns "id" */ Workspaces_Constraint["WorkspacePkey"] = "Workspace_pkey";
})(Workspaces_Constraint || (Workspaces_Constraint = {}));
export var Workspaces_Select_Column;
(function(Workspaces_Select_Column) {
    /** column name */ Workspaces_Select_Column["ApiApplicationId"] = "api_application_id";
    /** column name */ Workspaces_Select_Column["CreatedAt"] = "created_at";
    /** column name */ Workspaces_Select_Column["DeletedAt"] = "deleted_at";
    /** column name */ Workspaces_Select_Column["Id"] = "id";
    /** column name */ Workspaces_Select_Column["Name"] = "name";
    /** column name */ Workspaces_Select_Column["Owner"] = "owner";
    /** column name */ Workspaces_Select_Column["RegionId"] = "region_id";
    /** column name */ Workspaces_Select_Column["RepoId"] = "repo_id";
    /** column name */ Workspaces_Select_Column["UpdatedAt"] = "updated_at";
    /** column name */ Workspaces_Select_Column["VersionId"] = "version_id";
})(Workspaces_Select_Column || (Workspaces_Select_Column = {}));
export var Workspaces_Update_Column;
(function(Workspaces_Update_Column) {
    /** column name */ Workspaces_Update_Column["ApiApplicationId"] = "api_application_id";
    /** column name */ Workspaces_Update_Column["CreatedAt"] = "created_at";
    /** column name */ Workspaces_Update_Column["DeletedAt"] = "deleted_at";
    /** column name */ Workspaces_Update_Column["Id"] = "id";
    /** column name */ Workspaces_Update_Column["Name"] = "name";
    /** column name */ Workspaces_Update_Column["Owner"] = "owner";
    /** column name */ Workspaces_Update_Column["RegionId"] = "region_id";
    /** column name */ Workspaces_Update_Column["RepoId"] = "repo_id";
    /** column name */ Workspaces_Update_Column["UpdatedAt"] = "updated_at";
    /** column name */ Workspaces_Update_Column["VersionId"] = "version_id";
})(Workspaces_Update_Column || (Workspaces_Update_Column = {}));
export var Cursor_Ordering;
(function(Cursor_Ordering) {
    /** ascending ordering of the cursor */ Cursor_Ordering["Asc"] = "ASC";
    /** descending ordering of the cursor */ Cursor_Ordering["Desc"] = "DESC";
})(Cursor_Ordering || (Cursor_Ordering = {}));
export var Order_By;
(function(Order_By) {
    /** in ascending order, nulls last */ Order_By["Asc"] = "asc";
    /** in ascending order, nulls first */ Order_By["AscNullsFirst"] = "asc_nulls_first";
    /** in ascending order, nulls last */ Order_By["AscNullsLast"] = "asc_nulls_last";
    /** in descending order, nulls first */ Order_By["Desc"] = "desc";
    /** in descending order, nulls first */ Order_By["DescNullsFirst"] = "desc_nulls_first";
    /** in descending order, nulls last */ Order_By["DescNullsLast"] = "desc_nulls_last";
})(Order_By || (Order_By = {}));

//# sourceMappingURL=generated.js.map